<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useQuery } from '@tanstack/vue-query'
import dayjs from 'dayjs'
import { memberActivitiesApi } from '@/api/member'
import { useSessionStore } from '@/stores/session'
import BarBg from '@/assets/raffle/entry/home_banner_bg.png'
import WheelIcon from '@/assets/raffle/entry/home_wheel_icon.png'

const router = useRouter()
const sessionStore = useSessionStore()

const { data: activitiesData } = useQuery({
  queryKey: ['member-activities'],
  queryFn: async () => {
    const res = await memberActivitiesApi()
    return res.data
  },
  enabled: () => !!sessionStore.sessionId,
})

const luckyWheel = computed(() => activitiesData.value?.lucky_wheel ?? null)

const expiryText = computed(() => {
  if (!luckyWheel.value) return ''
  return dayjs.unix(luckyWheel.value.end_at).format('YYYY年MM月DD日')
})

const handleClick = () => {
  router.push('/activity/lucky-wheel')
}
</script>

<template>
  <div
    v-if="luckyWheel"
    class="lucky-wheel-entry mx-4 my-2 relative overflow-hidden rounded-xl cursor-pointer active:opacity-95"
    role="button"
    tabindex="0"
    @click="handleClick"
    @keydown.enter.prevent="handleClick"
  >
    <div
      class="absolute inset-0"
      :style="{ background: `url(${BarBg}) no-repeat center / 100% 100%` }"
      aria-hidden="true"
    />
    <div class="relative flex items-center gap-2 px-2 py-2 min-h-[57px]">
      <img :src="WheelIcon" alt="" class="w-12 shrink-0" />
      <div class="flex-1 min-w-0">
        <div class="text-white text-base font-bold leading-tight truncate">
          {{ luckyWheel.name }}
        </div>
        <div class="flex items-center gap-2">
          <div class="text-white/90 text-xs mt-0.5">参与抽奖赢LB大奖</div>
          <div
            class="shrink-0 bg-[#FFF6CA] rounded-full px-1.5 py-0.5 text-[11px] font-medium text-auxiliary-red whitespace-nowrap"
          >
            到期：{{ expiryText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
